import {deepClone, getUrlParams, StorageUtils} from "xmgoing-utils";
import {unref} from "vue";

/**
 * 获取用户定义对remarks对象集合
 * @param stateRemarks
 */
export function getUserDefStateRemarks(stateRemarks) {
  const newRemarks = [];
  stateRemarks.forEach((remarkItem) => {
    const {propType} = remarkItem;
    if (propType === "userProp") {
      newRemarks.push(deepClone(remarkItem));
    }
  })
  return newRemarks;
}

/**
 * 获取用户定义的默认state值
 * @param state
 * @param stateRemarks
 */
export function getUserDefState(state, stateRemarks) {
  const newState = {};
  stateRemarks.forEach((remarkItem) => {
    const {propType, value} = remarkItem;
    if (propType === "userProp") {
      newState[value] = state[value];
    }
  })
  return newState;
}

/**
 * 将state传递到子界面
 * 只需要传递用户定义到state值和记录，系统到参数不需要传递
 * @param state
 * @param stateRemarks
 */
export function transStateToSubPage(state, stateRemarks, params) {
  const userStateJson = getUserDefState(unref(state), unref(stateRemarks));
  const stateRemarksStr = getUserDefStateRemarks(unref(stateRemarks));
  StorageUtils.addSessionItem("stateJson", JSON.stringify(userStateJson));
  StorageUtils.addSessionItem("stateRemarksStr", JSON.stringify(stateRemarksStr));
  params['stateJson'] = JSON.stringify(userStateJson);
  params['stateRemarksStr'] = JSON.stringify(stateRemarksStr);
}

/**
 * 删除缓存
 */
export function removeSessionCache() {
  StorageUtils.removeSessionItem("stateJson");
  StorageUtils.removeSessionItem("stateRemarksStr");
}


/**
 * 获取父界面带过来的参数
 * @param pageModelsStore
 */
export function mergeSubVuex({pageModelsStore}) {
  // unref(state)['drawerDesIdStr']=true;
  const pageTypeParams = getUrlParams("pageType", true);
  if (pageTypeParams === 'subPageDes') {
    //合并变量值
    const stateJsonStr = StorageUtils.getSessionItem("stateJson") || getUrlParams("stateJson", true);
    if (stateJsonStr) {
      nextTick(() => {
        const stateObj = JSON.parse(stateJsonStr);
        pageModelsStore.setState(stateObj, false, 'parentVuex');
      })
    }
    //合并变量描述
    const stateRemarksStr = StorageUtils.getSessionItem("stateRemarksStr") || getUrlParams("stateRemarksStr", true);
    if (stateRemarksStr) {
      const stateRemarksObj = JSON.parse(stateRemarksStr);
      pageModelsStore.setStateRemarks(stateRemarksObj, false, 'parentVuex');
    }
  }
}


export function setStateValueByModelDrawerDes(state) {
  unref(state)['drawerDesIdStr'] = true;
}

/**
 * store文件加载后 对界面对state进行一个初始化
 * @param pageConfigs
 * @param pageModelsStore
 * @param initState
 */
export function _initStoreByConfig({pageConfigs, pageModelsStore, initState}) {
  Object.keys(unref(pageConfigs).state).forEach((propName) => {
    if (unref(pageConfigs).stateRemarks && Array.isArray(unref(pageConfigs).stateRemarks)) {
      const stateItem = unref(pageConfigs).stateRemarks.filter((itemDb) => {
        return itemDb.value === propName;
      })[0];
      try {
        if (stateItem) {
          const {dataType} = stateItem;
          if (dataType === 'object') {
            unref(pageConfigs).state[propName] = JSON.parse(unref(pageConfigs).state[propName])
          }
        }
      } catch (e) {
        console.error(e, "=====initStoreByConfig=====e")
      }
    }
  })
  pageModelsStore.setState(unref(pageConfigs).state, initState, initState === false ? 'subPageVuex' : '');
}

/**
 * 设置界面对状态说明信息
 * @param stateRemarks
 * @param initState
 * @param fromType
 * @param pageModelsObj
 */
export function _setStateRemarks({stateRemarks, initState, fromType}, pageModelsObj) {
  if (initState === false) {
    if (stateRemarks && Array.isArray(stateRemarks) && stateRemarks.length > 0) {
      stateRemarks.forEach((sItem) => {
        //如果需要加入的变量对象描述 不存在的才需要进行追加
        const itemObj = pageModelsObj.stateRemarks.filter((dbItem) => {
          return dbItem.value === sItem.value;
        })[0];
        if (!itemObj) {
          sItem.fromType = fromType;
          pageModelsObj.stateRemarks.push(sItem);
        }
      })
    }
  } else {
    if (stateRemarks && Array.isArray(stateRemarks)) {
      stateRemarks.forEach((itemObj) => {
        try {
          const {defValue, dataType} = itemObj;
          if (dataType === 'object') {
            itemObj['defValue'] = JSON.parse(defValue)
          }
        } catch (e) {
          console.error(e, "=======e")
        }
      })
    }
    pageModelsObj.stateRemarks = [...stateRemarks];
    pageModelsObj.initStateValues(pageModelsObj.stateRemarks);
  }
}
